// Kleine pure formatters, losgetrokken uit `catalog.ts` zodat modules
// die alleen een prijs willen tonen niet de volledige PRODUCTS-array
// (+ tientallen image-imports) hoeven binnen te halen.

export function formatEuro(cents: number): string {
  const v = cents / 100;
  return `€${v.toLocaleString("nl-NL", {
    minimumFractionDigits: v % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
}

export function applyDiscount(cents: number, discountPct: number): number {
  if (!discountPct || discountPct <= 0) return cents;
  return Math.round(cents * (1 - discountPct / 100));
}
